// extracted by mini-css-extract-plugin
export var JobOpeningsWrapper = "JobOpenings-module--JobOpeningsWrapper--zNCAJ";
export var JobOpeningsVector = "JobOpenings-module--JobOpeningsVector--R7i45";
export var JobOpeningsListing = "JobOpenings-module--JobOpeningsListing--pLWI-";
export var JobOpeningsListingItem = "JobOpenings-module--JobOpeningsListingItem--hMymg";
export var JobOpeningsGrid = "JobOpenings-module--JobOpeningsGrid--88KKh";